export { default as VendorDetails } from './details';